import { trackEvent, trackPageView } from 'iclinic-trackings';
import { Store } from 'redux';

import { getUserInfo } from 'features/onlinePayment/state/config/register/selectors';

export const createTrackingsActions = (store: Store) => {
  const getProfileId = () => {
    const state = store.getState();
    const user = getUserInfo(state);
    return user?.profileId ? Number(user.profileId) : null;
  };

  return {
    eventTracking: async (
      event: string,
      properties: Record<string, unknown> = {},
    ): Promise<void> => {
      const profileId = getProfileId();
      if (!profileId) return;

      await trackEvent(event, {
        iclinic_id: profileId,
        app_id: 'iclinic_web',
        ...properties,
      });
    },

    pageViewTracking: async (
      category: string,
      name: string,
      properties: Record<string, unknown> = {},
    ): Promise<void> => {
      const profileId = getProfileId();
      if (!profileId) return;

      await trackPageView(category, name, {
        iclinic_id: profileId,
        app_id: 'iclinic_web',
        ...properties,
      });
    },
  };
};
